
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as sq from '~/store/modules/sq'
import * as cart from '~/store/modules/cart'

const SQ = namespace(sq.name)
const Cart = namespace(cart.name)

@Component({
  components: {
    ServiceQualification: () => import('~/components/ServiceQualification.vue'),
    Location: () => import('~/components/Icons/Location.vue')
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class AddressBar extends Vue {
  @SQ.State
  sq

  @SQ.Mutation
  clearAddressString
  
  @Cart.Getter
  address

  changeAddress() {
    this.clearAddressString()
    this.$router.push({
      path: '/'
    })
  }
}
